module.exports = __webpack_public_path__ + "img/kefu.450d71a1.png";